<template>
  <v-text-field
    :value="value"
    @input="$emit('input', $event)"
    :rules="rules"
    :readonly="readonly"
    rounded
    filled
    dense
    color="secondary"
    background-color="transparent"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <slot name="label">{{ label }}</slot>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    label: { type: String, default: '' },
    value: [String, Number],
    rules: Array,
    readonly: Boolean,
  },
}
</script>
